/* src/app/main-dashboard/main-dashboard.component.scss */
:host::ng-deep .widget-overview-box {
  min-height: 141.5px;
}
:host::ng-deep .overview-detail .col-6:first-child {
  border-right: 1px solid #dee2e6 !important;
}
@media (min-width: 1200px) {
  :host::ng-deep .overview-title {
    font-size: 1rem;
  }
}
@media (min-width: 1400px) {
  :host::ng-deep .overview-title {
    font-size: 1.1rem;
  }
}
@media (min-width: 1500px) {
  :host::ng-deep .overview-title {
    font-size: 1.15rem;
  }
}
@media (min-width: 1600px) {
  :host::ng-deep .overview-title {
    font-size: 1.2rem;
  }
}
@media (min-width: 1900px) {
  :host::ng-deep .overview-title {
    font-size: 1.25rem;
  }
}
/*# sourceMappingURL=main-dashboard.component.css.map */
